// src/legal/legalVersion.js
export const RR_LEGAL_VERSION = "2.1";
